import { Theme, useMediaQuery } from '@mui/material';
import React from 'react';

import { Position } from '@work4all/models/lib/Classes/Position.entity';

import { MaskTabPanel } from '../../../../../mask-tabs';
import { INDIVIDUAL_TAB_ID } from '../../../../components/custom-fields/contants';
import { IndividualTabPanel } from '../../../../components/custom-fields/IndividualTabPanel';
import { MaskContent } from '../../../../components/MaskContent/MaskContent';
import { HistoryTabPanel } from '../../../../components/tab-panels/history/HistoryTabPanel';

import { AttachmentsTabPanel } from './attachments/AttachmentsTabPanel';
import { GeneralTabPanel } from './general/GeneralTabPanel';
import { MiscellaneousTabPanel } from './miscellaneous/MiscellaneousTabPanel';
import { PositionsTabPanel } from './positions/PositionsTabPanel';
import { TextTabPanel } from './text/TextTabPanel';

interface ErpTabPanelsProps {
  isCreateMode: boolean;
  renderIndividualTab: boolean;
  positionList: Position[];
}

export const ErpTabPanels: React.FC<ErpTabPanelsProps> = (props) => {
  const isTablet = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'));

  return (
    <MaskContent>
      {isTablet && (
        <MaskTabPanel value="general" useInert={false}>
          <GeneralTabPanel />
        </MaskTabPanel>
      )}

      <MaskTabPanel value="miscellaneous" useInert={false}>
        <MiscellaneousTabPanel positionList={props.positionList} />
      </MaskTabPanel>

      <MaskTabPanel value="text" useInert={false}>
        <TextTabPanel />
      </MaskTabPanel>

      <MaskTabPanel value="positions" useInert={false}>
        <PositionsTabPanel />
      </MaskTabPanel>

      <MaskTabPanel value="attachments" useInert={false}>
        <AttachmentsTabPanel />
      </MaskTabPanel>

      {!props.isCreateMode && (
        <MaskTabPanel value="history" useInert={false}>
          <HistoryTabPanel />
        </MaskTabPanel>
      )}

      {props.renderIndividualTab && (
        <MaskTabPanel value={INDIVIDUAL_TAB_ID} useInert={false}>
          <IndividualTabPanel />
        </MaskTabPanel>
      )}
    </MaskContent>
  );
};
